module.exports = __webpack_public_path__ + "static/img/cable_64.7b309d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cable_64.png
// module id = qSEg
// module chunks = 0